import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ROOT_URL } from '../../api/ApiConfig';

// Async thunk to fetch articles by category slug
export const getExternalArticleByCategory = createAsyncThunk(
  'kbCategory/getExternalArticleByCategory',
  async ({ businessName, categorySlug, group_id }, { rejectWithValue }) => {
    try {
      if (!businessName || !categorySlug) {
        throw new Error('Missing businessName or categorySlug');
      }

      const url = `${ROOT_URL}/kb/articles/external/${businessName}/${categorySlug}`;

      const response = await axios.get(url, {
        headers: {
          // Add authorization header if your API requires it
          // 'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: group_id ? { group_id } : undefined,
      });

      // Assuming the API returns something like:
      // { status: 200, message: "...", data: { category: {...}, articles: [...] } }
      return response.data;
    } catch (error) {
      console.error('Error fetching articles by category:', error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch articles for this category';

      return rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null,          // will hold the full response (category + articles array)
};

const getExternalArticleByCategorySlice = createSlice({
  name: 'getExternalArticleByCategory',
  initialState,
  reducers: {
    resetGetExternalArticleByCategoryState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExternalArticleByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getExternalArticleByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;           // full response object
        state.error = null;
      })
      .addCase(getExternalArticleByCategory.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;          // error message string
        state.data = null;

        // Show toast only on real error (not on manual rejectWithValue if you want to handle some cases silently)
        toast.error(action.payload || 'Failed to load articles');
      });
  },
});

export const { resetGetExternalArticleByCategoryState } = getExternalArticleByCategorySlice.actions;
export default getExternalArticleByCategorySlice.reducer;